<template>
  <div>
    <message-list-component
      :messages="errors"
      type="danger"
      clear-mutation="clearErrors"
      :show-delete-button="false"
      :show-icon="showIcon"
    />
    <message-list-component
      :messages="warnings"
      type="warning"
      clear-mutation="clearWarnings"
      :show-delete-button="showDeleteButton"
      :show-icon="showIcon"
    />
    <message-list-component
      :messages="successes"
      type="success"
      clear-mutation="clearSuccesses"
      :show-delete-button="showDeleteButton"
      :show-icon="showIcon"
    />
  </div>
</template>
<script>
import MessageBase from './MessageBase.vue'
import MessageListComponent from '@/components-v2/flows/LIDL/MessageView/MessageListComponent.vue'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'MessageModal',
  extends: MessageBase,
  components: {
    MessageListComponent
  },
  mixins: [slotProxy()],
  props: {
    showDeleteButton: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: false
    }
  }
}
</script>
